import { FC } from 'react';

import { Badge, Box, CheckOutline, ChevronDownOutline, HStack, Menu, MenuButton, MenuItem, MenuList, Text } from '@bonusly/design-system';

import { GoalStatus } from '../../../../types/goal';
import { getStatusLabel, getStatusStyles } from './goal-status-badge';

interface GoalStatusSelectProps {
	value: GoalStatus;
	onChange: (status: GoalStatus) => void;
	placeholder?: string;
}

export const GoalStatusSelect: FC<GoalStatusSelectProps> = ({ value, onChange, placeholder = 'Select status...' }) => {
	const statusStyle = getStatusStyles(value);
	const label = getStatusLabel(value);

	const handleStatusSelect = (newStatus: GoalStatus) => {
		onChange(newStatus);
	};

	const renderStatusMenuItem = (statusOption: GoalStatus) => {
		const isSelected = statusOption === value;
		const statusStyleOption = getStatusStyles(statusOption);
		const statusLabel = getStatusLabel(statusOption);

		return (
			<MenuItem key={statusOption} onClick={() => handleStatusSelect(statusOption)} p={2} borderRadius="md">
				<HStack justify="space-between" align="center" w="full">
					<Badge {...statusStyleOption} px={3} py={1} borderRadius="full" fontSize="sm" fontWeight="medium" textTransform="none">
						{statusLabel}
					</Badge>
					{isSelected && <CheckOutline size="sm" color="primary.fg" />}
				</HStack>
			</MenuItem>
		);
	};

	return (
		<Menu>
			<MenuButton as={Box} w="full">
				<Box
					{...statusStyle}
					w="full"
					px={3}
					borderRadius="md"
					border="1px solid"
					borderColor="border.default"
					cursor="pointer"
					transition="all 0.2s"
					height={10}
					alignItems="center"
					justifyContent="center"
					_hover={{
						borderColor: 'border.focus',
						boxShadow: '0 0 0 1px var(--chakra-colors-border-focus)',
					}}
				>
					<HStack justify="space-between" align="center" h="full">
						<Text fontWeight="medium" fontSize="md">
							{value ? label : placeholder}
						</Text>
						<ChevronDownOutline size="md" />
					</HStack>
				</Box>
			</MenuButton>
			<MenuList w="full" p={1}>
				{renderStatusMenuItem('not_started')}
				{renderStatusMenuItem('on_track')}
				{renderStatusMenuItem('at_risk')}
				{renderStatusMenuItem('off_track')}
				{renderStatusMenuItem('completed')}
			</MenuList>
		</Menu>
	);
};
